import { atom, useAtom } from 'jotai/index';
import { IEditPermission } from 'types';

const permissionListAtom = atom<IEditPermission[]>([]);
const isLoadingAtom = atom<boolean>(false);

export const usePermissionList = () => {
  const [permissionList, setPermissionList] = useAtom(permissionListAtom);
  const [isLoading, setIsLoading] = useAtom(isLoadingAtom);

  return {
    permissionList,
    setPermissionList,
    isLoading,
    setIsLoading,
  };
};
